import script from "./ManagementView.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagementView.vue?vue&type=script&setup=true&lang=js"

import "./ManagementView.vue?vue&type=style&index=0&id=856bd22c&scoped=true&lang=css"

import exportComponent from "/home/appiah/Documents/projects/greenfield/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-856bd22c"]])

export default __exports__